var TableContextInformation = /** @class */ (function () {
    function TableContextInformation(rowIndex, columnIndex, model) {
        this.rowIndex = rowIndex;
        this.columnIndex = columnIndex;
        this.model = model;
    }
    Object.defineProperty(TableContextInformation.prototype, "mode", {
        get: function () {
            if (this.model === undefined) {
                return 'header';
            }
            return 'data';
        },
        enumerable: false,
        configurable: true
    });
    return TableContextInformation;
}());
export default TableContextInformation;
//# sourceMappingURL=TableContextInformation.js.map